module.exports = __webpack_public_path__ + "img/4.9abb22fa.png";